import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import LocationList from "../components/settings/location/locationList";
import AddEditLocation from "../components/settings/location/addEditLocation";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const LocationStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"LocationList"}
            screenOptions={{ headerShown: false, animationEnabled: false }}>
            <AppStack.Screen name="LocationList" component={LocationList} />
            <AppStack.Screen name="AddEditLocation" component={AddEditLocation} />
        </AppStack.Navigator>
    );
};

export default LocationStack;